import "../../style/notes.css";

export default function Note({ content }) {
  return (
    <div
      className="notes"
      style={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
